var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qualify-sidebar-input-container"},[(_vm.label)?_c('label',{staticClass:"sidebar-input-label",class:_vm.brandColor},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.isMandatory)?[_vm._v("\n            ("+_vm._s(_vm.$t('mandatory'))+")\n        ")]:_vm._e()],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }